var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticClass:"tslc-button",class:{'tslc-button__secondary': _vm.type === 'secondary', 'tslc-button__danger': _vm.type === 'danger'},attrs:{"height":_vm.height,"width":_vm.width,"elevation":_vm.elevation,"loading":_vm.loading},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }